module.exports = __webpack_public_path__ + "static/media/wash-fold-service-icon.5af04a42.svg";